import { SET_SHOW_ART_WALL_SORT_BY } from './../const';

export default (showArtWallSortBy) => {
  return {
    type: SET_SHOW_ART_WALL_SORT_BY,
    showArtWallSortBy: showArtWallSortBy
  }
};
